export enum SortingOption {
  noSorting = "정렬 안 함",
  nameAsc = "이름 오름차순",
  nameDesc = "이름 내림차순",
  recentlyModified = "최근 수정순",
  old = "오래된 순",
  new = "최근 생성순"
}
